export const EVENT_REQUEST_PROGRESS = 'EVENT_REQUEST_PROGRESS';

export const BRAND_NAVATAR = 'navatar';

export const Key = {
    Tab: 'Tab',
    Enter: 'Enter',
    Escape: 'Escape',
    Up: 'ArrowUp',
    Down: 'ArrowDown',
  };

export const links = {
  filterManagerHelp: 'https://www.xappex.com/knowledge-base/' +
    'importing-data-from-salesforce-com-using-soql-salesforce-object-query-language-2/#dynamic',
}